import { Icon } from "./icon-model";

export enum typeAlertEnum {
    TRAFFIC = 'Trafico',
    AIRQUALITY = 'CalidadAire',
    PARKING = 'Parking'
}

export const iconTypeMap: {
    [key: string]: Icon
} = {
    [typeAlertEnum.PARKING]: Icon.parking_zones_y,
    [typeAlertEnum.AIRQUALITY]: Icon.AirIconNotify,
    [typeAlertEnum.TRAFFIC]: Icon.layer_traffic_yellow
}

export const notifationsAPIMapper = (
    apiObj: any
) => ({
    id: apiObj?.registerId,
    base_id: apiObj?.id,
    title: apiObj?.moduleName,
    subtitle: apiObj?.alertConfigName,
    icon: iconTypeMap[apiObj?.moduleCode],
    statusValue: `${apiObj?.value} ${apiObj?.measurementUnit}`,
    detectedDate: apiObj?.publicationDate,
    name: apiObj?.name,
    type: 'notification',
    stationName: apiObj?.stationName
});
